<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input-department"
        size="sm"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Подразделение"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
          class="text-small"
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";

export default {
  name: "DepartmentSelect",
  mixins: [ catalogs ],
  props: {
    isDisabled: Boolean,
    id: String
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null
    }
  },
  mounted() {
    if (this.$props.id != null) {
      this.configure(this.$props.id);
    }
  },
  methods: {
    async configure(id) {
      this.query = "";

      if (id > 0) {
        const location_cost_type = (await this.getDepartmentById(id)).data;
        if (location_cost_type != null) {
          this.query = location_cost_type.name;
          this.item = location_cost_type;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', null);
    },
    onClick(item) {
      this.query = item.name;
      this.item = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      const result = await this.getDepartmentSearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Departments/DepartmentSelect.vue